import React from 'react';
import './DispatchModal.scss';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../_common';
import dispatchIcon from '../../assets/dispatchSuccess.png';
import { useStoreContext } from '../App/StoreProvider';
import { LoadWithDriverItem } from '../../store/types/AddLoadModalState';
import { Row } from 'react-bootstrap';

interface ConfirmDispatchModalProps {
    onClickHide: () => void;
    show: boolean;
    isFromLoads: boolean;
    isSplitLoad: boolean;
}

const ConfirmDispatchModal = ({ show, onClickHide, isSplitLoad }: ConfirmDispatchModalProps): React.ReactElement => {
    const [state] = useStoreContext();
    const {
        addLoadModal: { loadsWithDrivers },
    } = state;
    const dispatchedLoads: LoadWithDriverItem[] = [];
    const createdLoads: LoadWithDriverItem[] = [];
    loadsWithDrivers.map(load => {
        if (load.driverId !== 0 || load.secondaryDriverId !== 0) {
            dispatchedLoads.push(load);
        } else if (load.driverId === 0 || load.secondaryDriverId === 0) {
            createdLoads.push(load);
        }
    });
    const splitLoadMessage = 'Split Load Request Sent';
    const dispatchedMessageEnd = dispatchedLoads.length > 1 ? 'loads' : 'load';
    const dispatchedMessage = `You have successfully dispatched ${dispatchedLoads.length} `.concat(
        dispatchedMessageEnd,
    );
    const createdMessageEnd = createdLoads.length > 1 ? 'loads' : 'load';
    const createdMessage = `You have successfully created ${createdLoads.length} `.concat(createdMessageEnd);

    return (
        <Modal show={show} onHide={onClickHide} backdrop="static">
            <Modal.Header className="ConfirmDispatchModal-Header">
                <Modal.Title className="ConfirmDispatchModal-Header-Container">
                    <i className="material-icons ConfirmDispatchModal-X-Button" onClick={onClickHide}>
                        close
                    </i>
                    <img className="ConfirmDispatchModal-Icon" src={dispatchIcon} alt="dispatch icon" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ConfirmDispatchModal-Body">
                {isSplitLoad ? <div className="ConfirmDispatchModal-Body-Header">{splitLoadMessage}</div> : <div></div>}
                {!isSplitLoad && dispatchedLoads.length > 0 ? (
                    <div className="ConfirmDispatchModal-Body-Header">{dispatchedMessage}</div>
                ) : (
                    <div></div>
                )}
                {!isSplitLoad && createdLoads.length > 0 ? (
                    <div className="ConfirmDispatchModal-Body-Header">{createdMessage}</div>
                ) : (
                    <div></div>
                )}
                {dispatchedLoads && dispatchedLoads.length === 1 ? (
                    <div className="ConfirmDispatchModal-Attribute-Container">
                        <div className="ConfirmDispatchModal-Attribute">
                            <div className="ConfirmDispatchModal-Attribute-Title">Load #: </div>
                            <div className="ConfirmDispatchModal-Attribute-Value">{dispatchedLoads[0].id}</div>
                        </div>

                        {dispatchedLoads[0].secondaryDriverId === 0 ? (
                            <div className="ConfirmDispatchModal-Attribute">
                                <div className="ConfirmDispatchModal-Attribute-Title">Driver: </div>
                                <div className="ConfirmDispatchModal-Attribute-Value">
                                    {dispatchedLoads[0].driverName}
                                </div>
                            </div>
                        ) : (
                            <div>
                                <Row>
                                    <div className="ConfirmDispatchModal-Attribute-Title">Driver 1: </div>
                                    <div className="ConfirmDispatchModal-Attribute-Value">
                                        {dispatchedLoads[0].driverName}
                                    </div>
                                </Row>
                                <Row>
                                    <div className="ConfirmDispatchModal-Attribute-Title">Driver 2: </div>
                                    <div className="ConfirmDispatchModal-Attribute-Value">
                                        {dispatchedLoads[0].secondaryDriverName}
                                    </div>
                                </Row>
                            </div>
                        )}
                    </div>
                ) : (
                    <div></div>
                )}
            </Modal.Body>
            <Modal.Footer className="ConfirmDispatchModal-Footer">
                <CustomButton title="OK" isDisabled={false} onClick={onClickHide}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDispatchModal;

